import { init } from './application'
import { registerServiceWorker } from './service-worker'

init()
registerServiceWorker()
